// eslint-disable-next-line import/prefer-default-export
export { default as HomePage } from './home-page';
export { default } from './home';



// WEBPACK FOOTER //
// ./src/home/index.js